<template>
  <v-dialog v-model="show" width="800px">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text class="text-xs-center">{{
        content || 'Are you sure?'
      }}</v-card-text>
      <v-card-actions>
        <v-btn @click="confirm">{{ action || 'はい' }}</v-btn>
        <v-btn @click="rejectBack">{{ rejectAction || '戻る' }}</v-btn>
        <v-btn @click="cancel">{{ cancelAction || 'キャンセル' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      title: null,
      content: null,
      resolve: null,
      reject: null,
      action: null,
      rejectAction: null,
      cancelAction: null,
    }
  },
  methods: {
    popup({
      title,
      content,
      action,
      resolve,
      reject,
      rejectAction,
      cancelAction,
    }) {
      this.show = true
      this.title = title
      this.content = content
      this.action = action
      this.rejectAction = rejectAction
      this.resolve = resolve
      this.reject = reject
      this.cancelAction = cancelAction
    },
    confirm() {
      this.show = false
      this.$emit('confirm')
    },
    rejectBack() {
      this.show = false
      this.$emit('reject')
    },
    cancel() {
      this.show = false
      this.$emit('cancel')
    },
  },
}
</script>
<style scoped></style>
